import React from 'react'
import { Divider as ChemistryDivider } from 'chemistry'

export function Divider(props) {
  return <ChemistryDivider width='100%' m='16px 0' {...props} />
}
